export default __webpack_public_path__ + "static/media/633.d89f02ee.jpg";